<div *ngIf="optOutEmails$ | async">
  <div *ngFor="let optOutEmail of optOutEmails">
    <input
      class="form-check-input"
      type="checkbox"
      (change)="optOutEmail.Status = $event.target.checked ? 1 : 0"
      [checked]="optOutEmail.Status === 1"
      [(ngModel)]="optOutEmail.Status"
      [id]="optOutEmail.EmailTypeId"
      required
    />
    <label class="form-check-label fw-normal" [for]="optOutEmail.EmailTypeId">
      {{ optOutEmail.Description }}
    </label>
  </div>
</div>
<fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
